/* ===========================================================================
   COLLECT THEM ALL - storefront half of the multi-buy offer

   >>> CURRENTLY OFF. ENABLED is false. <<<

   WHY IT IS OFF
   This file only ANNOUNCES a discount; the discount itself is a separate
   automatic discount in Shopify admin. At publish time that discount did not
   exist - a check of every discount on the shop found no "Collect them all"
   rule - so leaving this on would have told customers "Buy 2 or more bikes
   and save 10%" and then charged them full price at checkout. Turning it off
   was the difference between a missing feature and a broken promise.

   TO TURN IT BACK ON
   1. Admin -> Discounts -> Create discount -> Amount off products -> Automatic
        Applies to  Specific collections -> Bikes
        Value       10%
        Minimum     Minimum quantity of items = 2
        Combinations: product and order discounts off
   2. Test ONE custom build with one paid upgrade through to checkout. If 10%
      comes off a single bike, Shopify is counting the add-on line toward the
      minimum of 2 and the discount scope needs reworking.
   3. Set ENABLED below to true.

   WHY COUNT BY HANDLE INSTEAD OF TRUSTING THE CART COUNT
   A single custom build is several cart lines: the bike, plus one line per
   paid upgrade from the Builder Add-ons product. Counting lines - or item
   quantity - would read "3 items" for one bike with two upgrades and promise
   a discount that never arrives. Verified live: one build plus two upgrades
   counts as 1 bike and correctly shows "Add one more bike".

   KEEP IN SYNC: a new bike must be added to the Bikes collection AND to
   BIKE_HANDLES below, or the cart will under-count and stop offering the
   discount on an order that actually qualifies.

   WHERE IT MOUNTS IN THE CART
   .cart__ctas - the block holding the checkout button. The cart page and the
   cart drawer are different components with different ancestors, but both
   render that same class, so one selector covers both. This was read out of
   the live DOM rather than guessed: an earlier version targeted
   .cart-drawer__footer and .cart__footer, neither of which exists in this
   theme, and the nudge silently never appeared.
   =========================================================================== */
(function () {
  'use strict';

  var ENABLED = false;
  var MIN = 2;
  var PCT = 10;

  var BIKE_HANDLES = [
    'custom-mini-surron',
    'mini-surron-light-bee-x',
    'mini-surron-ultra-bee',
    'mini-stark-varg',
    'mini-talaria-x3-electric-bike-model'
  ];

  if (!ENABLED) return;

  function line(cls, text) {
    var n = document.createElement('p');
    n.className = cls;
    n.textContent = text;
    return n;
  }

  /* ---- 1. Product and builder pages: state the offer, once --------------- */
  function mountStatic() {
    if (document.querySelector('.pm-bundle:not(.pm-bundle-cart)')) return true;

    var anchor =
      document.querySelector('#pm-3d .pm-addcart') ||
      document.querySelector('main .product-details .add-to-cart-button') ||
      document.querySelector('main .add-to-cart-button:not(.sticky-add-to-cart__button)');

    if (!anchor) return false;

    anchor.insertAdjacentElement('afterend', line(
      'pm-bundle',
      'Buy ' + MIN + ' or more bikes and save ' + PCT + '%. Applied automatically at checkout.'
    ));
    return true;
  }

  /* The builder's Add to cart button is injected by another script, so it may
     not exist yet. Same retry shape as ar-view.js. */
  function mountStaticWhenReady() {
    var t = 0;
    var poll = setInterval(function () {
      t++;
      if (mountStatic() || t > 17) clearInterval(poll);
    }, 150);
  }

  /* ---- 2. The cart: how far off are they? -------------------------------- */
  function bikeCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (BIKE_HANDLES.indexOf(item.handle) > -1) n += item.quantity;
    });
    return n;
  }

  function message(n) {
    if (n === 0) return null;
    if (n < MIN) {
      var need = MIN - n;
      return 'Add ' + (need === 1 ? 'one more bike' : need + ' more bikes') +
             ' and save ' + PCT + '% on all of them.';
    }
    return PCT + '% off applied at checkout - ' + n + ' bikes.';
  }

  function paintCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = bikeCount(cart);
        var msg = message(n);

        Array.prototype.forEach.call(
          document.querySelectorAll('.pm-bundle-cart'),
          function (el) { el.remove(); }
        );
        if (!msg) return;

        Array.prototype.forEach.call(
          document.querySelectorAll('.cart__ctas'),
          function (ctas) {
            var el = line('pm-bundle pm-bundle-cart', msg);
            if (n >= MIN) el.classList.add('pm-bundle--won');
            ctas.insertAdjacentElement('beforebegin', el);
          }
        );
      })
      .catch(function () { /* never block the cart over a nudge */ });
  }

  /* The drawer is built from a fetch response, and the cart page re-renders
     its summary after an update, so .cart__ctas can appear long after any
     event we listened for. Watching the DOM is the only way to catch every
     repaint without polling forever. */
  function watch() {
    var pending = null;
    new MutationObserver(function () {
      if (!document.querySelector('.cart__ctas')) return;
      if (document.querySelector('.pm-bundle-cart')) return;
      clearTimeout(pending);
      pending = setTimeout(paintCart, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    mountStaticWhenReady();
    paintCart();
    watch();
    document.addEventListener('cart:update', paintCart);
    document.addEventListener('cart:refresh', paintCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
